if (window.innerWidth > 798) {
  new WOW().init();
}

if (window.innerWidth < 799) {
  
  var allTab = document.querySelectorAll(".pollutants__tab--titles .tab");
  if(allTab.length > 0){
    allTab.forEach(tab => {
      tab.addEventListener("click", function(){ 
        var slected_text = tab.closest('.custom__pollutants--tab-list').querySelector('.tab__dropdown');
        var drop_text = this.getAttribute('data-text');
        slected_text.textContent = drop_text;
        slected_text.classList.toggle("active");
        document.getElementById('tab__nav--target').style.height = "0px";
      });
    });
  }

  if(document.querySelector(".custom__pollutants--tab-list .tab__dropdown") != null){
    var dropdownBtn = document.querySelector(".custom__pollutants--tab-list .tab__dropdown");
    var mdiv = document.getElementById('tab__nav--target').offsetHeight;
    setTimeout(function(){
     document.getElementById("tab__nav--target").setAttribute("style", "opacity: 1; visibility: visible;height:0;");
    }, 1000);
    
    function slideToggle(ele) {
      if(dropdownBtn.classList.contains('active')){
        document.getElementById('tab__nav--target').style.height = "0px";
        ele.classList.remove('active');
      } else {
        document.getElementById('tab__nav--target').style.height = mdiv + "px";
        ele.classList.add('active');
      }
    }

    document.addEventListener("click", function(event) {
      var isClickInside = dropdownBtn.contains(event.target) || document.querySelector(".pollutants__tab--titles").contains(event.target);
      if (!isClickInside && dropdownBtn.classList.contains('active')) {
        slideToggle(dropdownBtn);
      }
    });
  }
  
}

// Footer do not sell
const doNotSellTrigger = document.querySelector('#do-not-sell-trigger');
if (doNotSellTrigger) {
  doNotSellTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    privacyBanner.showPreferences().then(() => {
      console.log('preferences modal opened');
    });
  });
}

// Match height js
function matchHeight(className) {
    var elements = document.querySelectorAll('.' + className);
    var rows = [];
    var currentRowTop = null;
    var currentRow = [];
    // Reset heights
    elements.forEach(function(element) {
        element.style.height = 'auto';
    });
    // Group elements by rows
    elements.forEach(function(element) {
        var rect = element.getBoundingClientRect();
        var top = rect.top;
        if (currentRowTop === null || top === currentRowTop) {
            currentRow.push(element);
            currentRowTop = top;
        } else {
            rows.push(currentRow);
            currentRow = [element];
            currentRowTop = top;
        }
    });
    rows.push(currentRow); // Push the last row
    // Apply max height to each row
    rows.forEach(function(row) {
        var maxHeight = 0;
        row.forEach(function(element) {
            var height = element.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        row.forEach(function(element) {
            element.style.height = maxHeight + 'px';
        });
    });
}

matchHeight('review__content');

window.addEventListener('load', function() {
    matchHeight('review__content');
});
window.addEventListener('resize', function() {
    matchHeight('review__content');
});
window.addEventListener('scroll', function() {
    matchHeight('review__content');
});


// custom section animation

// window.addEventListener('scroll', () => {
//     if (window.innerWidth <= 767) {
//         return; // Exit if window width is less than or equal to 767px
//     }
//     const video = document.querySelector('.fullscreen-video-wrap video');
//     const videoWrapper = document.querySelector('.custom__video--with-text .custom_container');
//     const customVideoSection = document.querySelector('.custom__video--with-text');
//     const text = document.querySelector('.video__text--content');
    
//     // Make sure elements are found
//     if (!video || !videoWrapper || !text) {
//         console.error("One or more elements not found");
//         return;
//     }

//     const scrollPosition = window.scrollY;
//     const section = videoWrapper;
//     const sectionTop = section.getBoundingClientRect().top;
//     const sectionHeight = section.getBoundingClientRect().height;
  
//     const sectionInView = Math.min(Math.max(0, (window.innerHeight - sectionTop) / sectionHeight), 1); // Clamped between 0 and 1

//     if (sectionInView >= 0.5) {
//         const widthValue = 50 + ((sectionInView - 0.5) * 100); // Scaling width from 50% to 100%
//         videoWrapper.style.width = `${Math.min(100, widthValue)}vw`;
//         videoWrapper.style.maxWidth = `${Math.min(100, widthValue)}vw`;
//         customVideoSection.classList.add("scrolled")
//     }else{
//       if(customVideoSection.classList.contains("scrolled")){
//         customVideoSection.classList.remove("scrolled")
//       }
//     }

//     // Show the text when the section is in view
//     if (sectionTop <= window.innerHeight * 0.5 && sectionTop >= 0) {
//         text.style.opacity = 1;
//         text.style.transition = 'opacity 0.5s ease'; // Smooth transition
//     } else if (sectionTop < 0 || sectionTop > window.innerHeight) {
//         // Hide the text if the section is scrolled out of view
//         text.style.opacity = 0;
//     }
// });

// window.addEventListener('scroll', function() {
//   if (window.innerWidth <= 767) {
//       return; // Exit if window width is less than or equal to 767px
//   }
//   const customReviewWithImage = document.querySelector('.custom__review--with-image');
//   const reviewImage = document.querySelector('.review__image--wrapper img');
//   const rect = customReviewWithImage.getBoundingClientRect();
//   const sectionHeight = rect.height;
//   const sectionTop = rect.top;
//   let sectionInView = Math.min(Math.max(0, (window.innerHeight - sectionTop) / sectionHeight), 1);

//   if (sectionInView >= 0.5 && sectionInView < 0.6) {
//     reviewImage.style.transform = 'scale(1.7)';
//   }else if (sectionInView >= 0.6 && sectionInView < 0.7) {
//     reviewImage.style.transform = 'scale(1.5)';
//   }else if (sectionInView >= 0.7 && sectionInView < 0.8) {
//     reviewImage.style.transform = 'scale(1.3)';
//   }else if (sectionInView >= 0.8) {
//     reviewImage.style.transform = 'scale(1)';
//   }else {
//     let scrollPercent = (window.innerHeight - rect.top) / (rect.height + window.innerHeight);
//     scrollPercent = Math.max(0, Math.min(scrollPercent, 1));
//     const scaleValue = 2.5 - scrollPercent;
//     reviewImage.style.transform = `scale(${scaleValue})`;
//   }
// });